import { createContext, useContext } from 'react'
import '@vp/pricing-context-module'

export const PricingContext = createContext<PricingContextModule.PcxtV3 | null>(null)

export const usePricingContext = () => useContext(PricingContext)
